/** @type {import("framer-motion").Variants} */
export const ANIMATE_OPACITY = {
  visible: {
    opacity: 1,
    transition: {},
  },
  hidden: {
    opacity: 0,
    transition: {},
  },
};

/** @type {import("framer-motion").Variants} */
export const ANIMATE_HEIGHT = {
  visible: {
    height: "auto",
    transition: {
      when: "beforeChildren",
    },
  },
  hidden: {
    height: 0,
    transition: {
      when: "afterChildren",
    },
  },
};

/** @type {import("framer-motion").Variants} */
export const ANIMATE_WIDTH = {
  visible: {
    width: "auto",
    transition: {
      when: "beforeChildren",
    },
  },
  hidden: {
    width: 0,
    transition: {
      when: "afterChildren",
    },
  },
};
